import React from 'react';
import { Notification, NotificationType } from '../../../../types/notifications';
import { CourseCompletionNotificationPane } from './CourseCompletionNotificationPane';
import { PracticalSectionResultNotificationPane } from './PracticalSectionResultNotificationPane';
import { TutorialCompletionNotificationPane } from '../../user_tutorial/TutorialCompletionNotificationPane';

type Props = {
  notification?: Notification;
};

export class NotificationPane extends React.Component<Props> {
  render() {
    const { notification } = this.props;
    if (!notification) {
      return null;
    }
    switch (notification.type) {
      case NotificationType.COURSE_COMPLETION:
        return <CourseCompletionNotificationPane notification={notification} />;
      case NotificationType.PRACTICAL_EXAM_RESULT:
        return <PracticalSectionResultNotificationPane notification={notification} />;
      case NotificationType.USER_TUTORIAL_COMPLETION:
        return <TutorialCompletionNotificationPane />;
      default:
        return null;
    }
  }
}
